//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilterCheckbox from "./Filter.vue";

export default {
	name: "CaroFilters",
	components: {
		FilterCheckbox,
	},
	data() {
		return {
			mobileFilterShow: false
		}
	},
	props: {
		filters: Array,
		results: Object,
		setFilterValue: Function,
		executeSearch: Function,
		extend: Function,
		extended: Object
	},
	computed: {
		locationModel: {
			get() {
				
				return this.extended?.location;
			},
			set(value) {
				this.extend(extended => {
					extended.location = value;
					return extended;
				})
			},
		},
		specialtyModel: {
			get() {
				if (!this.extended?.specialty?.id) return this.results.specialty.options[0].id
				else return this.extended?.specialty?.id;
			},
			async set(value) {
				this.extend(extended => {
					extended.specialty = this.results.specialty.options.find(o => o.id === value);
					return extended;
				})
				await this.executeSearch()
			},
		},
		languageModel: {
			get() {
				if (!this.extended?.language?.id) return this.results.languages.options[0].id
				else return this.extended?.language?.id;
			},
			async set(value) {
				this.extend(extended => {
					extended.language = this.results.languages.options.find(o => o.id === value);
					return extended;
				})
				await this.executeSearch()
			},
		}
	},
	methods: {
		clearAllDoctorFilters() {
			// resubmission reset
			if(!(Object.keys(this.extended).length === 0)) {
				this.extend(extended => {
					extended = {}
					return extended
				})
				return this.executeSearch()
			}
		}
	}
};
